import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ProtectedRoute from './components/protectedRoutes/ProtectedRoute';
import LoginPage from './pages/loginPage/LoginPage';
import Configuration from './components/configurationComp/Configuration';
import CreateUser from './components/createUserComp/CreateUser';
import CreateDepartment from './components/createDepartmentComp/CreateDepartment';
import AddUser from './components/addUserComp/AddUser';
import CreateWarning from './components/createWarningComp/CreateWarning';
import EditDepartment from './components/editDepartmentComp/EditDepartment';
import EditUser from './components/editUserComp/EditUser';
import EditWarning from './components/editWarningComp/EditWarning';
import EWS from './components/ewsComp/EWS';
import ActivityLog from './components/activityLogComp/ActivityLog';
import Callback from './pages/loginPage/CallBack';
import RegisterPage from './pages/registerPage/RegisterPage';
import AlertContainerComp from './components/alertComp/AlertContainerComp';
import Incidents from './components/incidentsComp/Incidents';
import { ThemeContextProvider } from './context/ThemeContext';
import { AlertContextProvider } from './context/AlertContext';
import CreateOrganization from './components/createOrganizationComp/CreateOrganization';
import OrganizationAddUser from './components/OrganizationAddUserComp/OrganizationAddUser';
import CreateEarlyWarning from './components/backOfficeSystem/createEarlyWarning/CreateEarlyWarning';
import Department from './components/backofficComp/department/Department';
import Roles from './components/backofficComp/roles/Roles';
import WarningWorkflowProcess from './components/warningWorkflowProcessComp/WarningWorkflowProcess';
import Email from './components/earlyWarning/emailComp/EarlyWarningMessages';
import ThemeSettings from './components/settingsComp/ThemeSettings';
import PluginSettings from './components/settingsComp/PluginSettings';
import ExternalEW from './components/ExternalEarlyWarningComp/ExternalEW';
import Subscribe from './components/backofficComp/subscribeComp/Subscribe';
import AddGroup from './components/backofficComp/addGroupsComp/AddGroup';
import AckEW from './components/ExternalEarlyWarningComp/AckEW';
import ForgotPassword from './pages/loginPage/ForgotPassword';
import ResetForgotPassword from './pages/loginPage/ResetForgotPassword';
import ChangePassword from './pages/changePassword/ChangePassword';
import SetupAwareness from './components/setupawareness/SetupAwareness';
import NewTemplate from './components/createWarningComp/SetupTemplate';
import SetupTemplate from './components/createWarningComp/SetupTemplate';
import Dashboard from './components/dashboardComp/Dashboard';
import TriggerTemplate from './components/createWarningComp/TriggerTemplate';
import CreateSimulation from './components/floodSimulation/CreateSimulation';
import SetupRecipients from './components/setupRecipients/SetupRecipients';
import FloodSimulation from './components/simulations/floodSimulation/FloodSimulation';
import TsunamiSimulation from './components/simulations/tsunamiSimulation/TsunamiSimulation';
import StormSurgeSimulation from './components/simulations/stormSurgeSimulation/StormSurgeSimulation';
import Setup from './components/backofficComp/setup/Setup';
import Acknowledgement from './components/acknowledgementComp/Acknowledgement';
import { UserDataProvider } from './context/UserDataContext';
import IncidentsNew from './components/incidentsComp/IncidentsNew';
import Tutorial01 from './components/tutorials/Tutorial';
import Tutorial from './components/tutorials/Tutorial';
import PolicyRoute from './components/protectedRoutes/PolicyRoute';
import Unauthorize from './pages/errorPages/Unauthorize';
import PageNotFound from './pages/errorPages/PageNotFound';
import { RunModeContextProvider } from './context/RunModeContext';
import UserDeletePage from './pages/userDeletePage/UserDeletePage';
import IncidentManage from './components/incidentManageComp/IncidentManage';
import LoginPageNew from './pages/loginPage/LoginPageNew';
import ForgotPasswordNew from './pages/loginPage/ForgotPasswordNew';
import ResetForgotPasswordNew from './pages/loginPage/ResetForgotPasswordNew';
import LoginPageNew2 from './pages/loginPage/LoginPageNew2';
import ForgotPasswordNew2 from './pages/loginPage/ForgotPasswordNew2';
import ResetForgotPasswordNew2 from './pages/loginPage/ResetForgotPasswordNew2';
import { NotificationProvider } from './context/NotificationContext';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

export const router = createBrowserRouter([
    {
        path: '/',
        element: (
            <NotificationProvider>
                <ThemeContextProvider>
                    <RunModeContextProvider>
                        <UserDataProvider>
                            <ProtectedRoute>

                                <AlertContextProvider>
                                    <>
                                        <App />
                                        <AlertContainerComp />
                                    </>
                                </AlertContextProvider>

                            </ProtectedRoute>
                        </UserDataProvider>
                    </RunModeContextProvider>
                </ThemeContextProvider>
            </NotificationProvider>
        ),
        children: [
            //{path: '/', element: <CreateWarning />},
            //{path: '/megha/configuration', element: <Configuration />},
            {
                path: '/megha/create_user', element: (
                    <PolicyRoute requiredPolicy='USER_MANAGE'>
                        <CreateUser />
                    </PolicyRoute>
                )
            },
            {
                path: '/megha/create_department', element: (
                    <PolicyRoute requiredPolicy='DEPARTMENT_MANAGE'>
                        <CreateDepartment />
                    </PolicyRoute>
                )
            },
            //{path: '/early_warning/workflow_diagram', element: <WorkflowDiagram />},
            {
                path: '/early_warning/workflow_diagram', element: (
                    <PolicyRoute requiredPolicy='WORKFLOW_MANAGE'>
                        <Configuration />
                    </PolicyRoute>
                )
            },
            {
                path: '/early_warning/add_user', element: (
                    <PolicyRoute requiredPolicy='USER_MANAGE'>
                        <AddUser />
                    </PolicyRoute>
                )
            },
            {
                path: '/early_warning/generate_warning', element: (
                    <PolicyRoute requiredPolicy='EARLY_WARNING'>
                        <CreateWarning />
                    </PolicyRoute>
                )
            },
            {
                path: '/edit/edit_department', element: (
                    <PolicyRoute requiredPolicy='DEPARTMENT_MANAGE'>
                        <EditDepartment />
                    </PolicyRoute>
                )
            },
            { path: '/edit/edit_profile', element: <EditUser /> },
            { path: '/edit/edit_warning', element: <EditWarning /> },
            { path: '/ews', element: <EWS /> },
            { path: '/activity_logs/activity_logs', element: <ActivityLog /> },
            { path: '/settings/theme_settings', element: <ThemeSettings /> },
            { path: '/settings/plugin_settings', element: <PluginSettings /> },
            /* {path: '/incidents', element: <Incidents />}, */
            {
                path: '/incidents/management', element: (
                    <PolicyRoute requiredPolicy='INCIDENT_MANGE'>
                        <IncidentsNew />
                    </PolicyRoute>
                )
            },
            {
                path: '/incidents/mapping', element: (
                    <PolicyRoute requiredPolicy='INCIDENT_MANGE'>
                        <IncidentManage />
                    </PolicyRoute>
                )
            },
            /* {path: 'sim/flood_simulation', element: <CreateSimulation />}, */
            {
                path: '/user_management/setup_organization', element: (
                    <PolicyRoute requiredPolicy='ORGANIZATION_MANAGE'>
                        <CreateOrganization />
                    </PolicyRoute>
                )
            },
            {
                path: '/user_management/setup_user', element: (
                    <PolicyRoute requiredPolicy='USER_MANAGE'>
                        <OrganizationAddUser />
                    </PolicyRoute>
                )
            },
            {
                path: '/settings/msg_configuration', element: (
                    <PolicyRoute requiredPolicy='MASSAGE_CONFIG'>
                        <Setup />
                    </PolicyRoute>
                )
            },
            {
                path: '/user_management/setup_department', element: (
                    <PolicyRoute requiredPolicy='DEPARTMENT_MANAGE'>
                        <Department />
                    </PolicyRoute>
                )
            },
            {
                path: '/user_management/setup_roles', element: (
                    <PolicyRoute requiredPolicy='USER_ROLE_MANGE'>
                        <Roles />
                    </PolicyRoute>
                )
            },
            {
                path: '/early_warning/early_warning_messages', element: (
                    <PolicyRoute requiredPolicy='EARLY_WARNING_MESSAGE'>
                        <Email />
                    </PolicyRoute>
                )
            },
            {
                path: '/user_management/setup_subscribers', element: (
                    <PolicyRoute requiredPolicy='SETUP_SUBSCRIBER'>
                        <Subscribe />
                    </PolicyRoute>
                )
            },
            {
                path: '/user_management/setup_groups', element: (
                    <PolicyRoute requiredPolicy='SETUP_GROUP'>
                        <AddGroup />
                    </PolicyRoute>
                )
            },
            {
                path: '/awareness/setup_awareness', element: (
                    <PolicyRoute requiredPolicy='AWARENESS_MANAGE'>
                        <SetupAwareness />
                    </PolicyRoute>
                )
            },
            { path: '/back_office_system/change_password', element: <ChangePassword /> },
            {
                path: '/early_warning/setup_template', element: (
                    <PolicyRoute requiredPolicy='SETUP_EARLY_WARNING_TEMPLATE'>
                        <SetupTemplate />
                    </PolicyRoute>
                )
            },
            { path: '/', element: <Dashboard /> },
            {
                path: '/early_warning/trigger_template', element: (
                    <PolicyRoute requiredPolicy='EARLY_WARNING'>
                        <TriggerTemplate />
                    </PolicyRoute>
                )
            },
            {
                path: '/sm/early_warning/setup_recipients', element: (
                    <PolicyRoute requiredPolicy='SETUP_RECIPIENT'>
                        <SetupRecipients />
                    </PolicyRoute>
                )
            },
            /* {path: '/sim/tsunami_simulation', element: <CreateTsunamiSimulation />}, */
            {
                path: '/simulations/flood', element: (
                    <PolicyRoute requiredPolicy='FLOOD_SIMULATION'>
                        <FloodSimulation />
                    </PolicyRoute>
                )
            },
            {
                path: '/simulations/tsunami', element: (
                    <PolicyRoute requiredPolicy='TSUNAMI_SIMULATION'>
                        <TsunamiSimulation />
                    </PolicyRoute>
                )
            },
            {
                path: '/simulations/stormSurge', element: (
                    <PolicyRoute requiredPolicy='STORM_SURGE_SIMULATION'>
                        <StormSurgeSimulation />
                    </PolicyRoute>
                )
            },
            {
                path: '/early_warning/acknowledgement', element: (
                    <PolicyRoute requiredPolicy='ACKNOWLEDGEMENT'>
                        <Acknowledgement />
                    </PolicyRoute>
                )
            },
            // {path: '/help/create_workflow', element: <Tutorial title="CREATE_WORKFLOW" />}
            { path: '/training', element: <Tutorial /> },

            {
                path: '/sm/early_warning/workflow_diagram', element: (
                    <PolicyRoute requiredPolicy='ACKNOWLEDGEMENT'>
                        <Configuration />
                    </PolicyRoute>
                )
            },
            { path: '/sm/early_warning/add_user', element: <AddUser /> },
            {
                path: '/sm/early_warning/generate_warning', element: (
                    <PolicyRoute requiredPolicy='EARLY_WARNING'>
                        <CreateWarning />
                    </PolicyRoute>
                )
            },
            {
                path: '/sm/early_warning/acknowledgement', element: (
                    <PolicyRoute requiredPolicy='ACKNOWLEDGEMENT'>
                        <Acknowledgement />
                    </PolicyRoute>
                )
            },
            {
                path: '/sm/early_warning/setup_template', element: (
                    <PolicyRoute requiredPolicy='SETUP_EARLY_WARNING_TEMPLATE'>
                        <SetupTemplate />
                    </PolicyRoute>
                )
            },
        ],
        errorElement: <PageNotFound />
    },
    {
        path: '/login',
        element: (
            <ThemeContextProvider>
                <UserDataProvider>
                    <AlertContextProvider>
                        {/* <LoginPage /> */}
                        {/* <LoginPageNew /> */}
                        {/* <LoginPageNew2 /> */}
                        <LoginPageNew2 />
                    </AlertContextProvider>
                </UserDataProvider>
            </ThemeContextProvider>
        ),
        errorElement: 'Error 404 Not Found'
    },
    {
        path: '/callback', element: (
            <UserDataProvider>
                <Callback />
            </UserDataProvider>
        )
    },
    { path: '/register', element: <RegisterPage /> },
    {
        path: '/early_warning_accept', element: (
            <ThemeContextProvider>
                <ExternalEW />
            </ThemeContextProvider>
        )
    },
    {
        path: '/ew_acknowledge', element: (
            <ThemeContextProvider>
                <AckEW />
            </ThemeContextProvider>
        )
    },
    {
        path: '/forgotpassword', element: (
            <ThemeContextProvider>
                {/* <ForgotPassword /> */}
                {/* <ForgotPasswordNew /> */}
                {/* <ForgotPasswordNew2 /> */}
                <ForgotPasswordNew2 />
            </ThemeContextProvider>)
    }, {
        path: '/reset_forgot_password', element: (
            <ThemeContextProvider>
                {/* <ResetForgotPassword /> */}
                {/* <ResetForgotPasswordNew /> */}
                {/* <ResetForgotPasswordNew2 /> */}
                <ResetForgotPasswordNew2 />
            </ThemeContextProvider>)
    },
    { path: '/unauthorized', element: <Unauthorize /> },
    { path: '/user_delete', element: <UserDeletePage /> }
])

root.render(
    <RouterProvider router={router} />
)
